import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { HoldingsModule } from '@ddt-web/holdings';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { FamilyFooterModule } from '../family-footer/family-footer.module';
import { FamilyChangesToHoldingsSkeletonComponent } from './family-changes-to-holdings-skeleton/family-changes-to-holdings-skeleton.component';
import { FamilyChangesToHoldingsComponent } from './family-changes-to-holdings.component';

@NgModule({
	declarations: [FamilyChangesToHoldingsComponent, FamilyChangesToHoldingsSkeletonComponent],
	imports: [
		AnalyticsModule,
		CommonModule,
		DataServiceModule,
		DisclosureModule,
		HoldingsModule,
		FamilyFooterModule,
		RouterModule.forChild([
			{ path: '', pathMatch: 'full', component: FamilyChangesToHoldingsComponent }
		]),
		NgxSkeletonLoaderModule,
		CwpNgFrameworkModule
	]
})
export class FamilyChangesToHoldingsModule { }
